export default __webpack_public_path__ + "0978864f2d8308658bbafd1c0b54f814.png";